import React, { Component } from "react";
import { VStack, HStack, Box, Text } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import ConfigService from "../../../../services/ConfigService";
import LocalImageDbService from "../../../../services/LocalImageDbService";
import LocalDocumentDbService from "../../../../services/LocalDocumentDbService";

const DelSwal = withReactContent(Swal);
export default class UserDocDisplay extends Component 
{

  constructor(props) {
    super(props);
    this.state = {
      isLocal: null,
      src: null,
      fallbackImgSrc: null,
      errored: false
  }

    this.localImageDbService = new LocalImageDbService;
    this.localDocumentDbService = new LocalDocumentDbService();
    this.configService = new ConfigService();

    this.onRemoveRequest = this.onRemoveRequest.bind(this);
}

async componentDidMount()
{
    var isLocalResponse = await this.localDocumentDbService.hasDocument(this.props.gcid, this.props.card.id);
    var isLocal = (isLocalResponse.data);
    var originalImgSrc = (isLocal) ?        
    (this.props.card.thumbnailUri) ? this.props.card.thumbnailUri :null
    : this.configService.getGcidUserImageBasePath(this.props.gcid) + this.props.card.thumbnailId + "." + this.props.card.thumbnailExt;

    var fallbackImgSrc = this.configService.getGlasschainCommonImagePath() + "pdf-fallback.png";
    var isLocalResult = await this.localDocumentDbService.hasDocument(this.props.gcid, this.props.card.id);
    this.setState({
      src: originalImgSrc,
      fallbackImgSrc: fallbackImgSrc,
      isLocal: isLocal
    });
}

onRemoveRequest()
{
    // confirm
    DelSwal.fire
    (
      {
        icon: "question",
        title: "Remove Document?",
        text: "Confirm you want to remove the attached document",
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel"
      }
    ).then(async (result) => {
      if (result.value) 
      {
        // now delete this image from the valuebag value
        var workingUserDocs = this.props.valueBag["userdocs"];
        var i = workingUserDocs.findIndex((doc) => doc.id === this.props.card.id);
        workingUserDocs.splice(i,1);
        // if we have a local version, get rid of it
        var hasLocalDocumentResponse = await this.localDocumentDbService.hasDocument(this.props.gcid, this.props.card.id);
        if (hasLocalDocumentResponse.data)
        {
            await this.localDocumentDbService.deleteDocument(this.props.card.id);
            // assume there is a thumbnail as well and delete that
            await this.localImageDbService.deleteImage(this.props.card.thumbnailId);
        }

        if (workingUserDocs.length < 1)
        {
          // we also need to update the hasUserImages property
          this.props.onValueChange('hasDocs', false);
        }
        this.props.onValueChange("userdocs", workingUserDocs);
        this.props.removeSchemaCard("notes", "Documents", this.props.card.id); 
        return DelSwal.fire({ icon: "success", text: "The document has been removed." });
      }
    }
    );
}

onError = () => {
  if (!this.state.errored) {
    this.setState({
      src: this.state.fallbackImgSrc,
      isErrored: true,
    });
  }
}


  render() 
  {
   

    console.log("Thumbnail Source:");
    console.info(this.state.src);


    var displayValue = this.props.card.descript ? this.props.card.descript : this.props.card.id; //this.props.cardValue;

    return (
      <VStack>
        {(this.state.src) &&
        <Box>
          { (!this.props.card.disallowRemove) &&
            <FontAwesomeIcon left="100%" style={{position: "absolute", border: "2px solid black", margin: "2px", backgroundColor: "black"}} icon={faXmark} color='white' onClick={(e) => this.onRemoveRequest(e)} />
          }
          <img src={this.state.src} onError={(e) => this.onError(e)}  width="200px" borderRadius="5px" alt="user image" maxH="10vw" />
        </Box>
        }
        <Text fontSize={{ base: "14px", md: "20px", lg: "24px" }} color="#0095c8" margin="0">
          {displayValue}
        </Text>
        <HStack spacing="5px">
        </HStack>
      </VStack>
    );
  }
}
